// extracted by mini-css-extract-plugin
export default {"main_page":"ypVAsjYy","errorPageSvg":"s12XeOZH","errorPageButton":"emvGo2ol"};
    if(module.hot) {
      // 1776432160964
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  